import type { Dispatch } from '@reduxjs/toolkit'
import {
  ChatArtifactsToolNames,
  ChatDocumentsToolNames,
  DashboardToolNames,
  DocsHubToolNames,
  TemplatesToolNames
} from '@atbash-labs/ontology-tools'

import { CHAT_ARTIFACTS_TAG_TYPES, chatArtifactsApi } from '../chat-artifacts/chat-artifacts-api'
import { DASHBOARDS_TAG_TYPES, dashboardsApi } from '../dashboards/dashboards-api'
import { TEMPLATES_TAG_TYPES, templatesApi } from '../dashboards/templates-api'
import { DOCS_HUB_TAG_TYPES, docsHubApi } from '../docs-hub/docs-hub-api'

const DASHBOARD_MUTATING_TOOL_NAMES: ReadonlySet<string> = new Set([
  DashboardToolNames.AddDashboard,
  DashboardToolNames.EditDashboard
])
const CHAT_ARTIFACT_MUTATING_TOOL_NAMES: ReadonlySet<string> = new Set([
  ChatArtifactsToolNames.AddChatArtifact,
  ChatArtifactsToolNames.EditChatArtifact,
  ChatDocumentsToolNames.AddChatDocument,
  ChatDocumentsToolNames.EditChatDocument,
  DocsHubToolNames.FillTemplate
])
const TEMPLATE_MUTATING_TOOL_NAMES: ReadonlySet<string> = new Set([
  TemplatesToolNames.AddTemplate,
  TemplatesToolNames.EditTemplate
])
const DOCS_HUB_MUTATING_TOOL_NAMES: ReadonlySet<string> = new Set([
  DocsHubToolNames.AddOrEditDoc,
  DocsHubToolNames.FindAndReplaceDoc
])

/** Refresh presentation caches changed by an orchestrator server tool. */
export function invalidateCompletedToolCaches(dispatch: Dispatch, toolName: string): void {
  if (CHAT_ARTIFACT_MUTATING_TOOL_NAMES.has(toolName)) {
    dispatch(chatArtifactsApi.util.invalidateTags([...CHAT_ARTIFACTS_TAG_TYPES]))
  }
  if (DASHBOARD_MUTATING_TOOL_NAMES.has(toolName)) {
    dispatch(dashboardsApi.util.invalidateTags([...DASHBOARDS_TAG_TYPES]))
  }
  if (TEMPLATE_MUTATING_TOOL_NAMES.has(toolName)) {
    dispatch(templatesApi.util.invalidateTags([...TEMPLATES_TAG_TYPES]))
  }
  if (DOCS_HUB_MUTATING_TOOL_NAMES.has(toolName)) {
    dispatch(docsHubApi.util.invalidateTags([...DOCS_HUB_TAG_TYPES]))
  }
}

/** Refresh caches from durable server-side resource-change events. */
export function invalidateChangedOntologyResourceCaches(
  dispatch: Dispatch,
  resource: 'documents'
): void {
  switch (resource) {
    case 'documents':
      dispatch(docsHubApi.util.invalidateTags([...DOCS_HUB_TAG_TYPES]))
  }
}
